import '../../Report.css'
import './ExperimentItem.css'

export type ExperimentItemProps = { index: number; title: string; score1: number; score2: number; img: string; science_description: string }

export const ExperimentItem = (props: ExperimentItemProps) => {
  return (
    <div className='exp-card-tem-box'>
      <div
        className='row'
        style={{ flex: 1 }}
      >
        <div style={{ flex: 1, height: '100%', padding: 20 }}>
          <div
            className='num-dot-item'
            style={{ marginTop: 20 }}
          >
            {props.index}
          </div>
          <p className='text-line exp-text-full'>{props.title}</p>
        </div>
        <div style={{ flex: 1, position: 'relative', backgroundColor: '#000', height: '100%' }}>
          <img
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              opacity: 0.8,
              top: 0,
              zIndex: 0,
            }}
            src={props.img}
          />
          <div
            style={{
              position: 'absolute',
              height: '100%',
              width: '100%',
              top: 0,
              zIndex: 1,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-around',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
              <p className='col-title'>Before</p>
              <div className='blur-col'>
                <p className='blur-col-num'>{props.score1}</p>
                <div
                  className='blur-col-inner'
                  style={{ height: `${props.score1 * 10}%`, opacity: props.score1 / 10 }}
                ></div>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
              <p className='col-title'>After</p>
              <div className='blur-col'>
                <p className='blur-col-num'>{props.score2}</p>
                <div
                  className='blur-col-inner'
                  style={{ height: `${props.score2 * 10}%`, opacity: props.score2 / 10 }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
